export type OrderStatus = "PENDING" | "SUCCESS" | "FAILED" | "MANUAL_REVIEW" | "CANCELLED";

export type Tone = "success" | "pending" | "danger" | "info" | "neutral";

export interface StatusMeta {
  label: { en: string; sw: string };
  message: { en: string; sw: string } | null;
  tone: Tone;
  canRepeat: boolean;
  terminal: boolean;
}

export const ORDER_STATUS: Record<OrderStatus, StatusMeta> = {
  SUCCESS: {
    label: { en: "Airtime sent", sw: "Muda umetumwa" },
    message: null,
    tone: "success",
    canRepeat: true,
    terminal: true,
  },
  PENDING: {
    label: { en: "Request pending", sw: "Ombi linasubiri" },
    message: {
      en: "Do not repeat this sale. We are checking with the network.",
      sw: "Usirudie mauzo haya. Tunakagua na mtandao.",
    },
    tone: "pending",
    canRepeat: false,
    terminal: false,
  },
  FAILED: {
    label: { en: "Not completed", sw: "Haijakamilika" },
    message: {
      en: "No airtime was sent and your money was returned.",
      sw: "Muda haujatumwa na pesa zako zimerejeshwa.",
    },
    tone: "danger",
    canRepeat: true,
    terminal: true,
  },
  MANUAL_REVIEW: {
    label: { en: "Under review", sw: "Inakaguliwa" },
    message: {
      en: "We are resolving this with the provider. Do not repeat this sale.",
      sw: "Tunatatua hili na mtoa huduma. Usirudie mauzo haya.",
    },
    tone: "info",
    canRepeat: false,
    terminal: true,
  },
  CANCELLED: {
    label: { en: "Cancelled", sw: "Imeghairiwa" },
    message: null,
    tone: "neutral",
    canRepeat: true,
    terminal: true,
  },
};

export type MnoCode = "vodacom" | "airtel" | "tigo" | "halotel" | "zantel" | "ttcl";

export interface Mno {
  code: MnoCode;
  name: string;
  colour: string;
  short: string;
}

export const MNOS: Record<MnoCode, Mno> = {
  vodacom: { code: "vodacom", name: "Vodacom", colour: "#E60000", short: "V" },
  airtel: { code: "airtel", name: "Airtel", colour: "#E40000", short: "A" },
  tigo: { code: "tigo", name: "Tigo", colour: "#0057B8", short: "T" },
  halotel: { code: "halotel", name: "Halotel", colour: "#F58220", short: "H" },
  zantel: { code: "zantel", name: "Zantel", colour: "#00A651", short: "Z" },
  ttcl: { code: "ttcl", name: "TTCL", colour: "#0B5CAB", short: "TT" },
};

export type KycStatus = "not_started" | "submitted" | "under_review" | "approved" | "rejected" | "info_required";
export type AgentStatus = "pending" | "active" | "suspended" | "closed";
export type AgentTier = "starter" | "standard" | "premier" | "super_dealer";
export type Channel = "mobile" | "web" | "ussd" | "api";
export type ProviderCode = "lipawakala" | "selcom" | "mock";
